import React, { useRef, useState } from "react";
import {
  Button,
  Col,
  Row,
  Table,
  Alert,
  Modal,
  Descriptions,
  Input,
  Space,
} from "antd";
import {
  SearchOutlined,
  DownloadOutlined,
  EyeOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { ExcelRenderer } from "react-excel-renderer";
import { saveAs } from "file-saver";
import util from "helpers/util";
import itemTakeApi from "constants/api/itemTake";

export default function CModal({ visible, onCancel, onClose, dataModal }) {
  const dateFormat = "DD/MM/YYYY";

  const [btnDownloadItemLoading, setBtnDownloadItemLoading] = useState(false);
  const [btnPreviewItemLoading, setBtnPreviewItemLoading] = useState(false);
  const [tbItemVisible, setTbItemVisible] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const handleOnClose = () => {
    setTbItemVisible(false);
    setRowsItem([]);
    setExcelData([]);
    onClose();
  };

  const handleOnCancel = () => {
    setTbItemVisible(false);
    setRowsItem([]);
    onCancel();
    return true;
  };

  //Item
  const [tbItemSearchText, setTbItemSearchText] = useState("");
  const [tbItemSearchedColumn, setTbItemSearchedColumn] = useState("");
  const tbItemSearchInput = useRef(null);
  const [rowsItem, setRowsItem] = useState([]);

  const tbItemGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbItemSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbItemHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => tbItemHandleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbItemHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbItemSearchText(selectedKeys[0]);
              setTbItemSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    // eslint-disable-next-line react/display-name
    render: (text) =>
      tbItemSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbItemSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const tbItemHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbItemSearchText(selectedKeys[0]);
    setTbItemSearchedColumn(dataIndex);
  };

  const tbItemHandleReset = (clearFilters) => {
    clearFilters();
    setTbItemSearchText("");
  };
  const columnsItem = [
    {
      title: "#",
      dataIndex: "index",
      width: 35,
      sorter: (a, b) => a.index - b.index,
      ...tbItemGetColumnSearchProps("index"),
    },
    {
      title: "Sku ID",
      dataIndex: "skuId",
      sorter: (a, b) => a.skuId.localeCompare(b.skuId),
      ...tbItemGetColumnSearchProps("skuId"),
    },
    {
      title: "Barcode",
      dataIndex: "vendorBarcode",
      sorter: (a, b) => a.vendorBarcode.localeCompare(b.vendorBarcode),
      ...tbItemGetColumnSearchProps("vendorBarcode"),
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      ...tbItemGetColumnSearchProps("description"),
    },
  ];

  //Store
  const [tbStoreSearchText, setTbStoreSearchText] = useState("");
  const [tbStoreSearchedColumn, setTbStoreSearchedColumn] = useState("");
  const tbStoreSearchInput = useRef(null);

  const tbStoreGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStoreSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStoreHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStoreSearchText(selectedKeys[0]);
              setTbStoreSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        // setTimeout(() => tbStoreSearchInput.select(), 100);
      }
    },
    // eslint-disable-next-line react/display-name
    render: (text) =>
      tbStoreSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbStoreSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const tbStoreHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStoreSearchText(selectedKeys[0]);
    setTbStoreSearchedColumn(dataIndex);
  };

  const tbStoreHandleReset = (clearFilters) => {
    clearFilters();
    setTbStoreSearchText("");
  };

  const columnsStore = [
    {
      title: "Store ID",
      dataIndex: "storeId",
      sorter: (a, b) => a.storeId - b.storeId,
      ...tbStoreGetColumnSearchProps("storeId"),
    },
    {
      title: "Store Name",
      dataIndex: "storeName",
      sorter: (a, b) => a.storeName.localeCompare(b.storeName),
      ...tbStoreGetColumnSearchProps("storeName"),
    },
  ];

  const columnBrand = [
    {
      title: "Brand ID",
      dataIndex: "brandId",
      sorter: (a, b) => a.storeId - b.storeId,
      ...tbStoreGetColumnSearchProps("brandId"),
    },
    {
      title: " Brand Name",
      dataIndex: "brandName",
      sorter: (a, b) => a.storeName.localeCompare(b.storeName),
      ...tbStoreGetColumnSearchProps("brandName"),
    },
  ];

  const handlePreviewItem = (token) => {
    setBtnPreviewItemLoading(true); 
    
    if (excelData.length == 0) {
      itemTakeApi
      .getFileItemTake(token)
      .then((res) => {
        var blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });
        setExcelData(blob);

        ExcelRenderer(blob, (err, resp) => {
          if (err) {
            util.displayApiError(err);
            setBtnPreviewItemLoading(false);
          } else {
            let param = [];
            let newRows = [];
            
            resp.rows.slice(1).map((row, index) => {
              if (row && row !== "undefined") {
                if (row[0]) param.push(row);
              } 
            });

            if (param.length === 0) {
              setBtnPreviewItemLoading(false);
              return false;
            } else {
              param.map((row, index) => {
                newRows.push({
                  key: row,
                  index: index + 1,
                  skuId: row[0],
                  vendorBarcode: row[1],
                  description: row[2]
                });
              });
              setRowsItem(newRows);
              setTbItemVisible(true);
              setBtnPreviewItemLoading(false);
            }
          }
        });
      })
      .catch((err) => {
        util.displayApiError(err);
        setBtnPreviewItemLoading(false);
      });
    }
    else {
      ExcelRenderer(excelData, (err, resp) => {
        if (err) {
          util.displayApiError(err);
          setBtnPreviewItemLoading(false);
        } else {
          let param = [];
          let newRows = [];
          
          resp.rows.slice(1).map((row, index) => {
            if (row && row !== "undefined") {
              if (row[0]) param.push(row);
            } 
          });

          if (param.length === 0) {
            setBtnPreviewItemLoading(false);
            return false;
          } else {
            param.map((row, index) => {
              newRows.push({
                key: row,
                index: index + 1,
                skuId: row[0],
                vendorBarcode: row[1],
                description: row[2]
              });
            });
            setRowsItem(newRows);
            setTbItemVisible(true);
            setBtnPreviewItemLoading(false);
          }
        }
      });
    }
    
  };

  const handleDownload = (token) => {
    setBtnDownloadItemLoading(true);

    if (excelData.length == 0) {
      itemTakeApi
      .getFileItemTake(token)
      .then((res) => {
        let blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });
        setExcelData(blob);

        let url = window.URL.createObjectURL(blob);
        saveAs(url, `${token}_item_take_list.xlsx`);
        setBtnDownloadItemLoading(false);
      })
      .catch((err) => {
        util.displayApiError(err);
        setBtnDownloadItemLoading(false);
      });
    }
    else {
      let url = window.URL.createObjectURL(excelData);
      saveAs(url, `${token}_item_take_list.xlsx`);
      setBtnDownloadItemLoading(false);
    }
  };
  return (
    <>
      <Modal
        width="90%"
        centered
        title="Item Take Detail"
        visible={visible}
        // onOk={onOk}
        onCancel={handleOnCancel}
        footer={[
          <Button
            key="close"
            onClick={handleOnClose}
            icon={<CloseCircleOutlined />}
          >
            Close
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <Descriptions
              bordered
              size="middle"
              // extra={<Button type="primary">Edit</Button>}
            >
              <Descriptions.Item label="Token">
                {dataModal?.token}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {dataModal?.status}
              </Descriptions.Item>
              <Descriptions.Item label="Action Date">
                {moment(dataModal?.actionDate).format(dateFormat)}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <br />
        <Row>
        <Col span={12} style={{ backgroundColor: "#DDF7F9", padding: 10 }}>
            <h3>Brand</h3>
            <Table
              loading={false}
              size="small"
              columns={columnBrand}
              dataSource={dataModal?.brands}
              // pagination={{ pageSize: 5 }}
              pagination={false}
              scroll={{ y: 200 }}
              bordered
            />
            <Alert
              message={`Total data: ${dataModal?.brands?.length} row(s)`}
              type="info"
              showIcon
            />
          </Col>
          <Col span={12} style={{ backgroundColor: "#DDF7F9", padding: 10 }}>
            <h3>Store</h3>
            <Table
              loading={false}
              size="small"
              columns={columnsStore}
              dataSource={dataModal?.stores}
              // pagination={{ pageSize: 5 }}
              pagination={false}
              scroll={{ y: 200 }}
              bordered
            />
            <Alert
              message={`Total data: ${dataModal?.stores?.length} row(s)`}
              type="info"
              showIcon
            />
          </Col>
          <Col span={12} style={{ backgroundColor: "#DDF7F9", padding: 10 }}>
            <Row>
              <Col span={6}>
                <h3>Item</h3>
              </Col>
              <Col
                span={18}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                }}
              >
                <Button
                  block
                  onClick={() =>
                    handleDownload(dataModal.token)
                  }
                  // block
                  loading={btnDownloadItemLoading}
                  type="dashed"
                  icon={<DownloadOutlined />}
                  size="small"
                >
                  Download Item (.xlsx)
                </Button>
                <Button
                  block
                  onClick={() => handlePreviewItem(dataModal.token)}
                  loading={btnPreviewItemLoading}
                  type="dashed"
                  icon={<EyeOutlined />}
                  size="small"
                >
                  Preview Item
                </Button>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                {tbItemVisible ? (
                  <>
                    <Table
                      loading={false}
                      size="small"
                      columns={columnsItem}
                      dataSource={rowsItem}
                      pagination={{ pageSize: 5 }}
                      //pagination={false}
                      scroll={{ y: 200 }}
                      bordered
                    />

                    <Alert
                      message={`Total data: ${rowsItem.length} row(s)`}
                      type="info"
                      showIcon
                    />
                  </>
                ) : (
                  <div></div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
